import { createSlice } from "@reduxjs/toolkit";
import { fetchNotificationsBuilder } from "./builder";

const initialState = {
  notifications: {
    data: [],
  },
};

export const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    fetchNotificationsBuilder(builder);
    builder.addCase("logout", () => initialState);
  },
});

export const selectNotifications = (state) => state.notifications.notifications;
export default notificationsSlice.reducer;
